export default __webpack_public_path__ + "static/Tek_Remote_Camera-3ccd8606fbbbf1cdcbe3135018242263.png";